import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getMapDataByDestination = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const { destinationId } = data;
        const response = await api('get', `mapdata/${destinationId}`);
        return response.data || [];
    });
